type CountsBySubjectFilter = {
  classId?: number;
  studentId?: number;
  from?: string;
  to?: string;
};

type EvaluationsBySubjectFilter = {
  classId?: number;
  studentId?: number;
  subjectId?: number;
  from?: string;
  to?: string;
};

type EntriesBySubjectFilter = {
  classId?: number;
  studentId?: number;
  subjectId?: number;
  from?: string;
  to?: string;
};

export const performanceAssessmentOverviewKeys = {
  all: ['performanceAssessmentsOverview'] as const,

  lists: () => [...performanceAssessmentOverviewKeys.all, 'list'] as const,

  countsBySubject: (filter: CountsBySubjectFilter) =>
    [
      ...performanceAssessmentOverviewKeys.lists(),
      'countsBySubject',
      filter.classId ?? null,
      filter.studentId ?? null,
      filter.from ?? null,
      filter.to ?? null,
    ] as const,

  evaluationsBySubject: (filter: EvaluationsBySubjectFilter) =>
    [
      ...performanceAssessmentOverviewKeys.lists(),
      'evaluationsBySubject',
      filter.classId ?? null,
      filter.studentId ?? null,
      filter.subjectId ?? null,
      filter.from ?? null,
      filter.to ?? null,
    ] as const,

  entriesBySubject: (filter: EntriesBySubjectFilter) =>
    [
      ...performanceAssessmentOverviewKeys.lists(),
      'entriesBySubject',
      filter.classId ?? null,
      filter.studentId ?? null,
      filter.subjectId ?? null,
      filter.from ?? null,
      filter.to ?? null,
    ] as const,
};
